import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import "../../Style/Theme/index.css";
const KycAnimation = () => {
  const container = useRef(null);
  const avatar = useRef(null);
  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: false,
      animationData: require("../../utils/lottie/roundLoader.json"),
    });
    lottie.loadAnimation({
      container: avatar.current,
      renderer: "svg",
      loop: false,
      animationData: require("../../utils/lottie/avatarAnimation.json"),
    });
  }, []);
  return (
    <div>
      <div
        className="lottieContainer animationFilter"
        ref={container}
        style={{
          width: "380px",
          height: "200px",
          position: "relative",
          alignContent: "center",
        }}
      >
        <img
          src="/assets/playButton.svg"
          alt="play"
          className={`playButton lottieBg`}
        />
        <div ref={avatar} className="avatarAnimation" />
      </div>
    </div>
  );
};

export default KycAnimation;
